<template>
    <div class="overview-details">
        <!-- <section class="detail-header">
            <h4 class="header-title">
                Account Details
            </h4>

            <span
                class="update-btn"
                @click="openUpdate()"
                v-if="accountDetails.status && accountDetails.status !== 0"
            >
                Update
            </span>
        </section>

        <section class="detail-container">
            <div class="detail-section">
                <section class="detail-item">
                    <span class="item-value">
                        {{ accountDetails.company_name || '-' }}
                    </span>

                    <span class="item-title">
                        Company Name
                    </span>
                </section>

                <section class="detail-item">
                    <span class="item-value">
                        {{ accountDetails.first_name ? `${accountDetails.first_name} ${accountDetails.last_name}` : '-'}}
                    </span>

                    <span class="item-title">
                        Host Name
                    </span>
                </section>    

                <section class="detail-item">
                    <span class="item-value">
                        {{ accountDetails.contact_no ? `${accountDetails.country_code} ${accountDetails.contact_no}` : '' }}
                    </span>

                    <span class="item-title">
                        Contact Number
                    </span>
                </section>    

                <section class="detail-item">
                    <span class="item-value email">
                        {{ accountDetails.email || '-' }}
                    </span>

                    <span class="item-title">
                        Email
                    </span>
                </section>    

                <section class="detail-item">
                    <span class="item-value">
                        {{ accountDetails.country || '-' }}
                    </span>

                    <span class="item-title">
                        Address
                    </span>
                </section>    

                <section class="detail-item">
                    <span class="item-value">
                        {{ accountDetails.zip_code || '-' }}
                    </span>

                    <span class="item-title">
                        Zip
                    </span>
                </section>    
            </div>

            <div class="detail-section">
                <section class="detail-item">
                    <span class="item-value">
                        -
                    </span>

                    <span class="item-title">
                        Issuance Date
                    </span>
                </section> 

                <section class="detail-item">
                    <span class="item-value">
                        {{ `$ ${accountDetails.price || 0}` }}
                    </span>

                    <span class="item-title">
                        Payment
                    </span>
                </section> 

                <section class="detail-item">
                    <span class="item-value">
                        -
                    </span>

                    <span class="item-title">
                        Billing Cycle
                    </span>
                </section> 

                <section class="detail-item">
                    <span class="item-value user">
                        {{ accountDetails.user_allocation ? `${accountDetails.user_allocation} User(s)` : '-' }}
                    </span>

                    <span class="item-title">
                        User Space
                    </span>
                </section> 
            </div>
        </section> -->

        <section class="btn-container">
            <button
                class="_approve"
                @click="openUpdate()"
                v-if="accountDetails.status === 1"
            >
                Update
            </button>

            <div v-if="accountDetails.status === 1">
                <button
                    class="_approve"
                    :disabled="accountDetails.is_disabled === 0"
                    @click="toggleEnableDisableAccount(true)"
                >
                    Enable
                </button>

                <button 
                    class="_deny"
                    :disabled="accountDetails.is_disabled === 1"
                    @click="toggleEnableDisableAccount(false)"
                >
                    Disable
                </button>
            </div>

            <div v-if="accountDetails.status === 0">
                <button
                    class="_suspend"
                    @click="approve()"
                >
                    Approve
                </button>

                <button
                    class="_deny"
                    @click="reject()"
                >
                    Reject
                </button>
            </div>
            
        </section>

        <section>
            <h3>
                Account Details
            </h3>

            <div class="group">
                <div class="info">
                    <label>Host Name</label>
                    <p>{{ accountDetails.first_name ? `${accountDetails.first_name} ${accountDetails.last_name}` : '-'}}</p>
                </div>

                <div class="info">
                   <label>Company Email</label>
                    <p>{{ accountDetails.email }}</p>
                </div>
            </div>

            <div class="group">
                <div class="info">
                    <label>Company Name</label>
                    <p>{{ accountDetails.company_name || '-' }}</p>
                </div>

                <div class="info">
                   <label>Host Email</label>
                    <p>{{ accountDetails.company_email || '-' }}</p>
                </div>
            </div>

            <div class="info">
                <label>Contact Number</label>
                <p>{{ accountDetails.contact_no ? `${accountDetails.country_code} ${accountDetails.contact_no}` : '' }}</p>
            </div>

            <div class="group">
                <div class="info">
                   <label> Address </label>
                    <p>{{ address }}</p>
                </div>

                <div class="info">
                   <label>Country</label>
                    <p>{{ accountDetails.country || '-' }}</p>
                </div>
            </div>


            <h3>Account Subscription</h3>

            <div class="group">
                <div class="info">
                    <label>Subscription Start</label>
                    <p>{{ accountDetails.subscription_start }}</p>
                </div>

                <div class="info">
                   <label>Expiry Date</label>
                    <p>{{ accountDetails.subscription_end }}</p>
                </div>
            </div>

            <div class="info">
                <label>Subscription Cycle</label>
                <p>cycle here</p>
            </div>

            <div class="info">
                <label>User Space </label>
                <p>{{ accountDetails.user_allocation }}</p>
            </div>

            <div class="info">
                <label>Company Type </label>
                <p>{{ accountDetails.company_type }}</p>
            </div>

            <div class="info">
                <label>Session Type </label>
                <p class="capitalize">{{ accountDetails.session_type }}</p>
            </div>

            <!-- <h3>Router and Band Details</h3>

            <div class="info">
                <label>Router Name</label>
                <p>router name herer</p>
            </div>

            <div class="info">
                <label>Router's MAC Address </label>
                <p>mac address</p>
            </div>

            <div class="info">
                <label>Router's IP Address </label>
                <p>IP address</p>
            </div>

            <div class="info">
                <label>Total Registered Bands</label>
                <p>registered bands total</p>
            </div> -->
        </section>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
    computed: {
        ...mapFields('accountOverview', [
            'accountDetails',
            'accountForm',
            'isUpdateAccount'
        ]),

        address () {
            const { bldg_apt_name, street, city } = this.accountDetails
            return `${bldg_apt_name} ${street}, ${city}`
        }
    },

    methods: {
        /* Toggle Update Account */
        async openUpdate () {
            if (this.accountDetails.status === 0) return

            const { id } = this.accountDetails

            this.$router.push(`/registered-accounts/edit/${id}`)
        },

        async approve () {
            const { id, country } = this.accountDetails

            if (country) {
                await this.getCountryZone(country)
                await this.getPartnerList(country)
            }

            this.isUpdateAccount = true

            this.$router.push(`/account-request/approve/${id}`)
        },

        toggleEnableDisableAccount (enableAccount) {
            const form = new FormData()
            form.append('id', this.accountDetails.id)
            form.append('account_status', 1)
            form.append('disable', enableAccount ? 0 : 1)

            this.$store.commit('modal/toggleModal', {
                modalType: 'warning',
                modalName: 'confirm-modal',
                modalDesc: `Are you sure you want to ${ enableAccount ? 'enable' : 'disable' } this account(s)?`,
                storeAction: 'accountOverview/enableDisableAccount',
                storePayload: form
            })
        },

        reject () {
            const form = new FormData()
            form.append('id', this.accountDetails.id)
            form.append('account_status', 0)

            this.$store.commit('modal/toggleModal', {
                modalType: 'warning',
                modalName: 'confirm-modal',
                modalDesc: 'Are you sure you want to reject this account?',
                storeAction: 'accountOverview/rejectAccount',
                storePayload: form
            })
        },

        getPartnerList (countryName) {
            this.$store.dispatch('global/getPartnerList', countryName)
        },

        getCountryZone (countryName) {
            this.$store.dispatch('global/getCountryZone', countryName)
        },
    },
}
</script>

<style lang="scss" scoped>
.overview-details {
    width: 600px;
    background-color: #fff;
    border-radius: 5px;
    flex-shrink: 0;
    padding: 20px;

    .btn-container {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 10px;

        button {
            margin-left: 10px;
        }
    }

    section {
        h3, .info, .group {
            margin-bottom: 15px;
        }

        h3 {
            padding: 10px 0;
            border-bottom: 1px solid #eee;
        }

        .group {
            display: flex;
            justify-content: flex-start;

            .info {
                flex: 1 1 50%;
            }
        }

        .info {
            text-align: left;

            label {
                width: 100%;
                font-weight: 600;
                margin-bottom: 10px;
            }

            p {
                width: 100%;
                color: #778395;
            }
        }

        .capitalize {
            text-transform: capitalize;
        }
    }
}
</style>